import { ErrorPage } from './ErrorPage';

export const errorRouter = {
  '@error': ErrorPage,
};
